import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useRemoveMarketFilterChipEvent } from '#src/hooks/events/useRemoveMarketFilterChipEvent.ts';
import { useFormatFilterWidgetValue } from '#src/hooks/search/useFormatFilterWidgetValue/index.tsx';
import { FilterChip } from '#src/search/ActiveFilters/FilterChip/index.tsx';

export const VirtualToggleActiveFilters = ({
  setVirtualToggleFilters,
}: {
  setVirtualToggleFilters: (virtualToggle: {
    [name: string]: string | string[] | boolean | undefined;
  }) => void;
}) => {
  const {
    favoriteFilter,
    notInLineUpFilter,
    competitionEligibilityFilter,
    customDecksFilter,
    gameweekFilter,
    dailyFilter,
    probablePitchersFilter,
    promotionalEvent,
    watchlistFilter,
  } = useSearchCardsContext();
  const trackRemoveMarketFilterChip = useRemoveMarketFilterChipEvent();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();
  const { sport } = useSportContext();

  const virtualToggleFilters = [
    {
      filter: VIRTUAL_TOGGLE_FILTERS.gameweekFilter,
      condition: gameweekFilter,
      value: gameweekFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.dailyFilter,
      condition: dailyFilter,
      value: dailyFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.probablePitchersFilter,
      condition: probablePitchersFilter,
      value: probablePitchersFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.favoriteFilter,
      condition: false,
      value: favoriteFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.notInLineupFilter,
      condition: notInLineUpFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.competitionEligibilityFilter,
      condition: competitionEligibilityFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.customDecksFilter,
      condition: customDecksFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.promotionalEventFilter,
      condition: promotionalEvent,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.watchlistFilter,
      condition: watchlistFilter,
    },
  ];

  return (
    <>
      {virtualToggleFilters
        .filter(({ condition }) => !!condition)
        .map(virtualToggle => {
          const labels = formatFilterWidgetValue(virtualToggle.filter);
          return labels.map((label, index) => (
            <FilterChip
              key={typeof label === 'string' ? label : index}
              label={label}
              onClose={() => {
                setVirtualToggleFilters({
                  [virtualToggle.filter.name]:
                    virtualToggle.filter.defaultValue,
                });
                if (sport) {
                  let trackValue = virtualToggle.value?.toString();
                  if (!trackValue && typeof label === 'string') {
                    trackValue = label;
                  }
                  if (trackValue) {
                    trackRemoveMarketFilterChip(
                      virtualToggle.filter.trackingName,
                      trackValue,
                      sport
                    );
                  }
                }
              }}
            />
          ));
        })}
    </>
  );
};
